/**
 * Quote/catalog pricing helpers (flat vs per-sq-ft).
 * Lot areas use **square feet** (same as `parcel.acres.Acres` in the form).
 */

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMoneyUsd(amount) {
  if (typeof amount !== "number" || !Number.isFinite(amount)) return "";
  return USD.format(amount);
}

export function formatRatePerSqFt(dollarsPerSqFt) {
  if (typeof dollarsPerSqFt !== "number" || !Number.isFinite(dollarsPerSqFt) || dollarsPerSqFt < 0) return "";
  return `${USD.format(dollarsPerSqFt)}/sq ft`;
}

/** Normalized service shape includes pricingModel ('flat' | 'per_sqft'), pricePerSqFt, price (display string). */
export function quoteServiceDisplayPrice(service, totalLotSqFt) {
  if (!service) return "";
  const model = service.pricingModel === "per_sqft" ? "per_sqft" : "flat";
  if (model === "flat") {
    return typeof service.price === "string" ? service.price : "";
  }
  const rate = Number(service.pricePerSqFt);
  if (!Number.isFinite(rate) || rate < 0) return service.price || "";

  const sqft =
    typeof totalLotSqFt === "number" && Number.isFinite(totalLotSqFt) && totalLotSqFt > 0
      ? totalLotSqFt
      : null;
  if (sqft == null) {
    return formatRatePerSqFt(rate) || service.price || "Per sq ft";
  }
  const total = Math.round(sqft * rate * 100) / 100;
  return `${formatMoneyUsd(total)} (${formatRatePerSqFt(rate)}, ${sqft.toLocaleString()} sq ft)`;
}

export function quoteServiceEmailPrice(service, totalLotSqFt) {
  const display = quoteServiceDisplayPrice(service, totalLotSqFt);
  if (display) return display;
  return typeof service.price === "string" ? service.price : "";
}
